"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("./Utils");
exports.RT_UNMOUNT = Symbol("RT:UNMOUNT");
// Record
class Record {
    constructor(prev, snapshot, data) {
        this.prev = { record: prev, backup: prev };
        this.snapshot = snapshot;
        this.data = data;
        this.changes = new Set();
        this.conflicts = new Map();
        this.observers = new Map();
        this.outdated = new Set();
    }
    freeze() {
        Object.freeze(this.data);
        Utils_1.Utils.freezeSet(this.changes);
        Utils_1.Utils.freezeMap(this.conflicts);
        Object.freeze(this);
    }
    static archive(r) {
        if (r !== Record.empty) {
            // Utils.freezeSet(r.outdated);
            // Utils.freezeMap(r.observers);
        }
    }
}
exports.Record = Record;
Record.markChanged = function (r, prop, changed, value) {
    /* istanbul ignore next */ return Utils_1.undef(); // to be redefined by Cache implementation
};
Record.markViewed = function (r, prop) {
    /* istanbul ignore next */ return Utils_1.undef(); // to be redefined by Cache implementation
};
